import axios from "axios"

const BACK_URL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACK_URL
const API = axios.create({ baseURL: BACK_URL })

// Accion que ocurre en cada request
API.interceptors.request.use((req) => {
    if (localStorage.getItem("profile")) {
        req.headers.Authorisation = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`
    }
    return req
})

/***** Aquí se reciben funciones del servidor. Luego ir a actions *****/

export const fetchFeed = (text) => API.get(`/feed?text=${text}`)

export const fetchPost = (id) => API.get(`/posts/${id}`)
export const fetchMyPosts = (id) => API.get(`/posts?id=${id}`)
export const fetchPopularPosts = () => API.get(`/posts`)
export const fetchPostsByPage = (info) => API.get(`/posts?page=${info.page}&limit=${info.limit}&userId=${info.userId}&lang=${info.lang}`)
export const fetchPostsBySearch = (searchQuery) => API.get(`/posts/search?searchQuery=${searchQuery.search || 'none'}&rss=${searchQuery.rss || 'none'}&tags=${searchQuery.tags}&lang=${searchQuery.lang}&limit=${searchQuery.limit}&page=${searchQuery.page}`)
export const createPost = (newPost) => API.post('/posts', newPost)
export const likePost = (id) => API.patch(`/posts/${id}/likePost`)
export const updatePost = (id, updatedPost) => API.patch(`/posts/${id}`, updatedPost)
export const deletePost = (id) => API.delete(`/posts/${id}`)

export const fetchScores = (info) => API.get(`/scores?userId=${info.userId}&limitB=${info.limitB}&limitU=${info.limitU}`)
export const createScore = (newScore) => API.post("/scores", newScore)
export const deleteScore = (id) => API.delete(`/scores/${id}`)
export const updateScore = (id, updatedScore) => API.patch(`/scores/${id}`, updatedScore)
export const updateScorePuntos = (updatedScore) => API.patch(`/scores`, updatedScore)

export const signIn = (formData) => API.post("/user/signin", formData)
export const signUp = (formData) => API.post("/user/signup", formData)

export const checkGoogleSessionToken = async (access_token) => {
    try {
        const googleData = await axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${access_token}`, {
            headers: {
                Authorization: `Bearer ${access_token}`,
                Accept: 'application/json'
            }
        })
        return googleData.data
    } catch (error) {
        throw new Error("Login error");
    }
}
